var map = {
	"./alexa.png": "7d4f",
	"./apple-store.svg": "00e5",
	"./google-play-badge.png": "cd2b",
	"./jumbo-unsplash.png": "47cb",
	"./jumbo_image.jpg": "0a0b",
	"./logo.svg": "e347",
	"./meal-details.png": "be43",
	"./pantry.png": "741b",
	"./plan-your-meals.png": "56a3",
	"./shopping-list.png": "48c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";